import React from 'react';

const lightBulbSvg = (props: {[key: string]: any}) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" {...props}>
        <path d="M149.996 0C67.157 0 .001 67.161.001 149.997S67.157 300 149.996 300s150.003-67.163 150.003-150.003S232.835 0 149.996 0zm-1.245 218.468c-12.893 0-23.342-11.082-23.342-24.764h46.685c-.001 13.682-10.453 24.764-23.343 24.764zm21.662-37.773h-43.326c-1.167-12.753-31.476-23.871-31.476-55.747 0-33.999 25.425-52.027 53.135-52.709h.006c27.712.685 53.135 18.71 53.135 52.709.002 31.876-30.307 42.994-31.474 55.747z"/>
    </svg>
);

export default lightBulbSvg;
